import React from "react";
import { PropTypes } from 'prop-types';

const Button2 = ({
  color,
  onClick,
  formdisable,
  disabled,
  width,
  height,
  word,
}) => {
  return (
    <button
      disabled={disabled || formdisable}
      onClick={onClick}
      style={{ color: `${color}`, height: `${height}`, width: `${width}` }}
      className="button-app-back"
      type="button"
    >
      {word}
    </button>
  );
};

Button2.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  formdisable: PropTypes.func,
  disabled: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  word: PropTypes.string,
}

export default Button2;
